// extracted by mini-css-extract-plugin
export default {"container":"LearnWin_container__0l18x","heading":"LearnWin_heading__Q1OC9","subheading":"LearnWin_subheading__kqdLN","grid":"LearnWin_grid__RxGkj","card":"LearnWin_card__A98yj"};